/** Podporované jazyky */
export const SUPPORTED_LOCALES = Object.freeze(["cs", "en"]);

/** Jazyk, který se použije, když není zvolena preference. */
export const DEFAULT_LOCALE = "cs";

/** fallback */
export const FALLBACK_LOCALE = "cs";

/**
 * Mapování primárního jazyka prohlížeče na podporovaný jazyk.
 * Čeština a slovenština -> CZ, všechny ostatní jazyky -> FOREIGN_LOCALE.
 */
export const BROWSER_LOCALE_MAP = Object.freeze({
  cs: "cs",
  sk: "cs",
});

/** Jazyk pro návštěvníky, jejichž jazyk prohlížeče není v BROWSER_LOCALE_MAP. */
export const FOREIGN_LOCALE = "en";

/** Klíč v localStorage pro ručně zvolený jazyk. */
export const STORAGE_KEY = "locale";

/** Popisky jazyků v přepínači */
export const LOCALE_LABELS = Object.freeze({
  cs: "CZ",
  en: "EN",
});

/** Locale pro Intl API */
export const INTL_LOCALES = Object.freeze({
  cs: "cs-CZ",
  en: "en-GB",
});

/**
 * TODO: Vícejazyčnost programu skrze API portal.falconea.com
 * localeParam: název query parametru, kterým API přijme jazyk (např. "lang")
 * Hodnota null = API jazyk nepodporuje, program se načítá bez parametru
 */
export const PROGRAM_API = Object.freeze({
  localeParam: null,
});
